<template>
  <div class="container_0 hover-shadow">
    <div class="contact_1" v-if="!manageScheduleList || manageScheduleList.length < 1">
      创建人不是客服 或提交时没有排班
    </div>

    <div v-for="e in manageScheduleList" :key="e.id">
      <div>
        <b>商家信息:</b>
        {{e.companyName}}({{e.merchantId}})
      </div>
      <div>
        <b>店铺信息:</b>
        {{e.shopName}}({{e.shopId}})
      </div>
      <div>
        <b>店铺类型:</b>
        {{e.shopType | shopType}}
      </div>
      <div>
        <b>订单编号:</b>
        {{e.orderCode}}({{e.orderId}})
      </div>
      <div>
        <b>排班日期:</b>
        {{e.scheduleDate}}
      </div>
      <div>
        <b>发布时间:</b>
        {{e.publishTime}}
      </div>
      <div>
        <b>打卡时间:</b>
        {{e.signInTime}}
      </div>
      <div>
        <b>排班状态:</b>
        {{1 == e.scheduleStatus ? '已发布' : '未发布'}}
      </div> <!-- 0：未发布、1：发布 -->
    </div>
  </div>
</template>

<style scoped>
  .container_0 {
    padding: 5px;
    border: 1px solid #dcdfe6;
  }

  .container_0 .contact_1 {
    margin: -5px;
    border : 0;
    color:#c7c7c7;
  }
</style>

<script>
export default {
    name : 'CustomerScheduleInfo',

    props : ['customerId', 'scheduleTime'],

    data() {
      return {
        manageScheduleList : []
      };
    },

    mounted() {
        this.loadCustomerScheduleInfo();
    },

    watch : {
      customerId() {
        this.loadCustomerScheduleInfo();
      },

      scheduleTime() {
        this.loadCustomerScheduleInfo();
      }
    },

    methods : {
      loadCustomerScheduleInfo() {
        if ( !this.customerId && !this.scheduleTime ) {
          // console.log('#28 loadCustomerScheduleInfo return, customerId=', this.customerId, ', scheduleTime=', this.scheduleTime);
          return;
        }

        var _this = this;
        sdk.ManageScheduleApi().listByCustomerIdAndScheduleTime({
          customerId : _this.customerId,
          scheduleTime : _this.scheduleTime
        }).then(res => {
          _this.manageScheduleList = res;
        });
      }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/CustomerScheduleInfo.vue